import { render } from "./SplitOrderModal.vue?vue&type=template&id=32519bc4&scoped=true"
import script from "./SplitOrderModal.vue?vue&type=script&lang=js"
export * from "./SplitOrderModal.vue?vue&type=script&lang=js"

import "./SplitOrderModal.vue?vue&type=style&index=0&id=32519bc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32519bc4"]])

export default __exports__